export default [
  { title: 'Add new', icon: 'mdi-plus', action: 'addNew', _enabled: true },
  {
    title: 'Import from CSV',
    icon: 'mdi-publish',
    action: 'importDevices',
    _enabled: true
  }
];
